import React from "react"
import * as S from "./article-card.styles"
import parse from "html-react-parser"

const ArticleCard = ({ title, slug, excerpt, featuredImage, date }) => {
  if (!title) return null

  return (
    <S.Wrapper>
      <S.Link url={`${slug}`}>
        <S.ImageContainer>
          {featuredImage && (
            <S.Image className="blogImage" img={featuredImage.node} />
          )}
        </S.ImageContainer>
        <S.TextWrapper>
          <S.Date>{date}</S.Date>
          <S.Title>{title}</S.Title>
          {excerpt && <S.Excerpt>{parse(excerpt)}</S.Excerpt>}
        </S.TextWrapper>
      </S.Link>
    </S.Wrapper>
  )
}

export default ArticleCard
